// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

type Props = {
  open: boolean,
  onClose: (confirmed: boolean) => void,
};

const SignOutConfirmDialog = (props: Props) => {
  const { t } = useTranslation();
  const { open, onClose } = props;

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{t('Sign out')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('Confirm to sign out')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="default">
          {t('Cancel')}
        </Button>
        <Button onClick={() => onClose(true)} color="primary" variant="contained">
          {t('Sign out')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignOutConfirmDialog;
